import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { EmailEstudo } from './email-estudo';
import { EmailEstudoService } from './email-estudo.service';
import { MatSnackBar, MatPaginator, MatTableDataSource, PageEvent } from '@angular/material';
import { UsuarioEmsVo } from '../util/usuario-ems-vo';

@Component({
  selector: 'app-email-estudo',
  templateUrl: './email-estudo.component.html',
  styleUrls: ['./email-estudo.component.css']
})
export class EmailEstudoComponent implements OnInit {

  @Input()  idEstudo: number;
  public lista: EmailEstudo[];
  // datatable variables
  public columnsToDisplay = [
    'descricao',
    'para',
    'de',
    'data'   
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public dataSource = new MatTableDataSource<EmailEstudo>(this.lista);
  // MatPaginator Output
  pageEvent: PageEvent;

  public email: EmailEstudo;
  public isLoading: boolean;

  constructor(
    private mensagem: MatSnackBar,
    private emailService: EmailEstudoService
  ) {


  }

  ngOnInit() {
    this.isLoading = true;  
    this.email = new EmailEstudo();
    this.dataSource.paginator = this.paginator;
    this.email.codigoEstudoSocioEconomico = this.idEstudo;    
    this.carregar(this.email);
    this.preencheMensagem();
  }

  carregar(emailEstudo: EmailEstudo){
    this.emailService.filtrar(emailEstudo).subscribe(
      (results: EmailEstudo[]) => {
        this.lista = results;
        this.dataSource = new MatTableDataSource<EmailEstudo>(results);
        this.dataSource.paginator = this.paginator;        
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  preencheMensagem(){
    const storage = JSON.parse(localStorage.getItem('sae'));
    const resource_owner = storage.resource_owner;
    
    if(resource_owner){
      this.email.descricao = "Caro(a) aluno(a) \n\n\n ";      
      this.emailService.recuperaEmailUsuarioLogado(resource_owner.id).subscribe((result: UsuarioEmsVo) => {
        if(result){
          this.email.descricao += " \n\n\n\n Em caso de dúvidas, entrar em contato com: " + result.email;
          this.email.de = result.email;
        }        
      });
    }    
  }

  public salvar() {
    this.isLoading = true;
    this.emailService.update(this.email).subscribe(
      result => {
        let estudoEmail = new EmailEstudo();
        estudoEmail.codigoEstudoSocioEconomico = this.idEstudo;
        this.carregar(estudoEmail);
        this.mensagem.open('E-mail enviado com sucesso!', 'X', {
          duration: 5000
        });
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }


  private erro(erro: string): void {
    this.mensagem.open(erro, 'X', { duration: 5000 });
    this.isLoading = false;
  }
}
